// Shared Nepali (BS) / AD date helper. Used by Accounts and Sales; owns no data.
// Nepali (Bikram Sambat) ↔ AD dates, driven by the BS calendar stored in the
// database (acc_bs_calendar). Dates are always stored once, as an AD date
// ("YYYY-MM-DD"); BS is derived for display and input.
export const BS_MONTHS = ["Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Poush", "Magh", "Falgun", "Chaitra"];
const AD_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const DAY = 86400000;
const toUtc = (iso) => { const [y, m, d] = iso.split("-").map(Number); return Date.UTC(y, m - 1, d); };
const toIso = (ms) => new Date(ms).toISOString().slice(0, 10);
export const addDays = (iso, n) => toIso(toUtc(iso) + n * DAY);
export const fmtAd = (iso) => { if (!iso) return "—"; const [y, m, d] = iso.slice(0, 10).split("-").map(Number); return `${d} ${AD_MONTHS[m - 1]} ${y}`; };
export const bsMonthLabel = (y, m) => `${BS_MONTHS[m - 1]} ${y}`;
export const fyLabel = (bsYear) => `${bsYear}/${String((bsYear + 1) % 100).padStart(2, "0")}`;

export function makeCalendar(rows = []) {
    const months = rows.map(r => ({ ...r, startMs: toUtc(r.ad_start), endIso: addDays(r.ad_start, r.days - 1) }))
        .sort((a, b) => a.startMs - b.startMs);
    const byKey = new Map(months.map(r => [`${r.bs_year}-${r.bs_month}`, r]));
    return {
        months,
        month: (y, m) => byKey.get(`${y}-${m}`),
        adToBs(iso) {
            if (!iso) return null;
            const t = toUtc(iso.slice(0, 10));
            const r = months.find(x => t >= x.startMs && t < x.startMs + x.days * DAY);
            return r ? { y: r.bs_year, m: r.bs_month, d: Math.round((t - r.startMs) / DAY) + 1, verified: r.verified } : null;
        },
        bsToAd(y, m, d) {
            const r = byKey.get(`${y}-${m}`);
            return r && d >= 1 && d <= r.days ? addDays(r.ad_start, d - 1) : null;
        },
        years: [...new Set(months.map(r => r.bs_year))],
    };
}

export const fmtBs = (bs) => (bs ? `${bs.d} ${BS_MONTHS[bs.m - 1]} ${bs.y}` : null);

// "1 Shrawan 2082 · 17 Jul 2025" (BS first) or the reverse, per Accounts settings.
export function fmtDual(iso, cal, display = "BS") {
    if (!iso) return "—";
    const ad = fmtAd(iso);
    const bs = fmtBs(cal?.adToBs(iso));
    if (!bs) return `${ad} · BS not available`;
    return display === "AD" ? `${ad} · ${bs}` : `${bs} · ${ad}`;
}
